// World 15 (Cairn) — fifth post-launch expansion world. First non-clear
// OBJECTIVE world: levels are won by satisfying coordinate markers, not by
// emptying the board. See packages/engine/src/objective.ts (case 'target').
//
// This is the first world where "clear the board" can be the wrong answer.
// A chain that empties the board is a failure mode if it consumes the tile
// that was supposed to land on a target. Players unlearn 14 worlds of "empty
// the board" reflex; the strongest form of teaching is unlearning.
//
// Spec: docs/future/w15-cairn-spec.md.
//
// Progression: L1-L8 are r=3 1-target intro/middle (d=2-5), L9 is r=3
// 2-target (d=6), L10 is r=4 2-target closer (d=7). Difficulty band d=2-7
// recalibrated from spec's aspirational d=6-8 after empirical probe found
// target objectives are inherently shallower than 'clear' (placement is
// typically a single slide once the colored tile exists).
//
// Generator: tools/generate-parallel.mjs --world 15 (180s solver budget,
// targetCount=1-3 across cfg0..cfg3, mixed r=3/r=4 geometry). Seed
// 0xaebd0000. cfg0+cfg1+cfg2 finished in ~63 minutes producing 140
// candidates; cfg3 (3-target closer config) was killed at the 1.5h mark
// without finishing — its 3-target output is a v1.0.x stretch. Pool
// curated via tools/finalize-w15.mjs.
//
// Worker config dist (3 of 4 completed):
//   cfg0 r=3 t=10 c=3 tc=1: 33/100 accepted, depths d=2-5 (mostly d=2-3)
//   cfg1 r=3 t=11 c=4 tc=2: 31/100 accepted, depths d=2-6 (peak d=4-5)
//   cfg2 r=4 t=12 c=4 tc=2: 76/100 accepted, depths d=2-7 (peak d=5-6)
//
// Status: shipping in v0.12.0 alongside the v0.11.5/v0.11.9 expansion
// content. iOS picks W15 up in the v1.0.1 bundle.
import type { LevelDef } from '@tessera/engine';
import { WORLD_15_HANDCRAFTED } from './world15-handcrafted';
import { WORLD_15_GENERATED } from './world15-generated';

// Generator output is the source of truth. The hand-authored fallback
// set (world15-handcrafted.ts) is preserved for reference but not
// merged in — generator-curated levels have better difficulty calibration
// across the d=2-7 progression. WORLD_15_HANDCRAFTED is referenced here
// only to silence the "unused export" warning and document its existence
// for future regeneration runs.
void WORLD_15_HANDCRAFTED;
export const WORLD_15_LEVELS: LevelDef[] = [...WORLD_15_GENERATED];
